/* Al-Aqeeq hero: curling steam, bean bursts from the sack, golden dust, floating beans and mouse parallax. */
(function () {
  var hero = document.querySelector('[data-yc-hero-fx]');
  if (!hero) return;
  if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  var img = hero.querySelector('.yc-hero__bg');
  var cv = hero.querySelector('.yc-hero__fx');
  if (!img || !cv) return;
  var ctx = cv.getContext('2d');
  var fine = window.matchMedia && window.matchMedia('(pointer: fine)').matches;
  /* Points on the photo, as fractions of the original image (1500 x 1035). */
  var CUP = { x: 0.708, y: 0.748, w: 0.055 };
  var SACK = { x0: 0.625, x1: 0.725, y: 0.468, floor: 0.975 };
  var COLORS = ['#3a2115', '#4a2b1a', '#2f190f', '#5b3522', '#432616'];
  var map, W = 0, H = 0, ribbons = [], beans = [], dust = [], floaters = [], running = false, last = 0;
  var nextBean = 0, nextRibbon = 0, nextBurst = 1200, raf, mx = 0, my = 0, px = 0, py = 0;

  function layout() {
    img.style.transform = ''; cv.style.transform = '';
    var r = hero.getBoundingClientRect(), ir = img.getBoundingClientRect();
    var d = Math.min(window.devicePixelRatio || 1, 2);
    W = r.width; H = r.height;
    cv.width = Math.round(W * d); cv.height = Math.round(H * d);
    ctx.setTransform(d, 0, 0, d, 0, 0);
    var iw = img.naturalWidth || 1500, ih = img.naturalHeight || 1035;
    var s = Math.max(ir.width / iw, ir.height / ih), dw = iw * s, dh = ih * s;
    var pos = getComputedStyle(img).objectPosition.split(' ');
    var ox0 = parseFloat(pos[0]) / 100, oy0 = parseFloat(pos[1] || '50%') / 100;
    if (isNaN(ox0)) ox0 = 0.5; if (isNaN(oy0)) oy0 = 0.5;
    var ox = ir.left - r.left + (ir.width - dw) * ox0, oy = ir.top - r.top + (ir.height - dh) * oy0;
    map = {
      s: s,
      p: function (fx, fy) { return { x: ox + fx * dw, y: oy + fy * dh }; },
      top: ir.top - r.top, bottom: ir.bottom - r.top
    };
    var nd = Math.round(Math.min(70, W / 22));
    dust = [];
    for (var i = 0; i < nd; i++) dust.push(newDust(true));
    floaters = [];
    var nf = W < 750 ? 3 : 7;
    for (var j = 0; j < nf; j++) floaters.push(newFloater(true));
  }

  function newDust(anywhere) {
    return { x: Math.random() * W, y: anywhere ? Math.random() * H : H + 10, r: 0.6 + Math.random() * 1.8, v: 0.15 + Math.random() * 0.45, ph: Math.random() * 6.28, a: 0.25 + Math.random() * 0.55 };
  }
  function newFloater(anywhere) {
    var z = 0.5 + Math.random() * 1.1;
    return { x: anywhere ? Math.random() * W : -40, y: H * (0.15 + Math.random() * 0.75), z: z, r: 7 * z * Math.max(0.7, map.s), a: Math.random() * 6.28, va: (Math.random() - 0.5) * 0.01, vx: 0.12 + z * 0.18, ph: Math.random() * 6.28, c: COLORS[(Math.random() * COLORS.length) | 0] };
  }

  function ribbon(t) {
    var c = map.p(CUP.x + (Math.random() - 0.5) * CUP.w, CUP.y);
    ribbons.push({ x: c.x, y: c.y, born: t, life: 3200 + Math.random() * 1800, ph: Math.random() * 6.28, amp: (10 + Math.random() * 14) * map.s, rise: (120 + Math.random() * 90) * map.s, w: (2 + Math.random() * 3) * map.s, lean: (Math.random() - 0.5) * 30 * map.s });
  }

  function bean(t, burst) {
    var a = map.p(SACK.x0 + Math.random() * (SACK.x1 - SACK.x0), SACK.y);
    var sp = burst ? 1.8 : 1;
    beans.push({ x: a.x, y: a.y, vx: (Math.random() - 0.5) * (burst ? 3.2 : 0.9) * map.s, vy: -(1.6 + Math.random() * 1.8) * sp * map.s, a: Math.random() * 6.28, va: (Math.random() - 0.5) * (burst ? 0.5 : 0.25), born: t, b: 0, c: COLORS[(Math.random() * COLORS.length) | 0] });
  }

  function drawBean(x, y, r, a, col, alpha, glint) {
    ctx.save(); ctx.globalAlpha = alpha; ctx.translate(x, y); ctx.rotate(a);
    var g = ctx.createRadialGradient(-r * 0.35, -r * 0.4, r * 0.1, 0, 0, r * 1.3);
    g.addColorStop(0, '#9a6239'); g.addColorStop(0.45, col); g.addColorStop(1, '#160a05');
    ctx.fillStyle = g; ctx.beginPath(); ctx.ellipse(0, 0, r * 1.25, r * 0.88, 0, 0, 6.2832); ctx.fill();
    ctx.strokeStyle = 'rgba(12,5,2,.9)'; ctx.lineWidth = Math.max(1, r * 0.22);
    ctx.beginPath(); ctx.moveTo(-r, 0); ctx.bezierCurveTo(-r * 0.35, -r * 0.35, r * 0.35, r * 0.35, r, 0); ctx.stroke();
    if (glint) { ctx.fillStyle = 'rgba(255,225,180,.35)'; ctx.beginPath(); ctx.ellipse(-r * 0.45, -r * 0.4, r * 0.38, r * 0.16, -0.4, 0, 6.2832); ctx.fill(); }
    ctx.restore();
  }

  function frame(t) {
    if (!running) return;
    var dt = Math.min(48, t - (last || t)); last = t;
    var k = dt / 16.7;
    ctx.clearRect(0, 0, W, H);

    /* parallax */
    if (fine) {
      px += (mx - px) * 0.06 * k; py += (my - py) * 0.06 * k;
      var tr = 'translate3d(' + (px * -14).toFixed(2) + 'px,' + (py * -10).toFixed(2) + 'px,0) scale(1.03)';
      img.style.transform = tr; cv.style.transform = tr;
    }

    /* golden dust (whole hero) */
    ctx.globalCompositeOperation = 'lighter';
    for (var d = 0; d < dust.length; d++) {
      var p = dust[d];
      p.y -= p.v * k; p.x += Math.sin(t / 1400 + p.ph) * 0.25 * k;
      if (p.y < -10) dust[d] = p = newDust(false);
      var tw = 0.55 + 0.45 * Math.sin(t / 500 + p.ph * 3);
      var gr = ctx.createRadialGradient(p.x, p.y, 0, p.x, p.y, p.r * 4);
      gr.addColorStop(0, 'rgba(255,214,140,' + (p.a * tw) + ')'); gr.addColorStop(1, 'rgba(255,214,140,0)');
      ctx.fillStyle = gr; ctx.beginPath(); ctx.arc(p.x, p.y, p.r * 4, 0, 6.2832); ctx.fill();
    }

    ctx.save();
    ctx.beginPath(); ctx.rect(0, map.top, W, map.bottom - map.top); ctx.clip();

    /* curling steam ribbons */
    if (t > nextRibbon) { ribbon(t); nextRibbon = t + 220 + Math.random() * 200; }
    ctx.lineCap = 'round';
    for (var i = ribbons.length - 1; i >= 0; i--) {
      var rb = ribbons[i], age = (t - rb.born) / rb.life;
      if (age >= 1) { ribbons.splice(i, 1); continue; }
      var fade = Math.sin(age * Math.PI);
      var segs = 14, len = Math.min(1, age * 1.6);
      ctx.beginPath();
      for (var s = 0; s <= segs; s++) {
        var u = s / segs * len, h = u * rb.rise + age * rb.rise * 0.35;
        var sx = rb.x + Math.sin(rb.ph + u * 5 + t / 900) * rb.amp * (0.3 + u) + rb.lean * u * u;
        var sy = rb.y - h;
        if (s === 0) ctx.moveTo(sx, sy); else ctx.lineTo(sx, sy);
      }
      ctx.strokeStyle = 'rgba(255,246,232,' + (0.05 * fade) + ')'; ctx.lineWidth = rb.w * 6; ctx.stroke();
      ctx.strokeStyle = 'rgba(255,248,238,' + (0.09 * fade) + ')'; ctx.lineWidth = rb.w * 2.6; ctx.stroke();
      ctx.strokeStyle = 'rgba(255,252,246,' + (0.14 * fade) + ')'; ctx.lineWidth = rb.w; ctx.stroke();
    }
    ctx.globalCompositeOperation = 'source-over';

    /* beans: steady trickle + bursts */
    if (t > nextBean) { bean(t, false); nextBean = t + 300 + Math.random() * 380; }
    if (t > nextBurst) { var n = 7 + (Math.random() * 6 | 0); while (n--) bean(t, true); nextBurst = t + 2600 + Math.random() * 1800; }
    var floor = map.p(0, SACK.floor).y, br = Math.max(2.8, 4.4 * map.s), mid = map.p((SACK.x0 + SACK.x1) / 2, 0).x;
    for (var j = beans.length - 1; j >= 0; j--) {
      var b = beans[j];
      b.vy += 0.24 * map.s * k; b.x += b.vx * k; b.y += b.vy * k; b.a += b.va * k;
      if (b.vy > 0 && !b.landed) b.vx += (b.x < mid ? -0.025 : 0.025) * k;
      if (b.y > floor) {
        b.y = floor;
        if (b.b < 2 && Math.abs(b.vy) > 1) { b.vy *= -0.42; b.vx *= 0.7; b.va *= 0.6; b.b++; }
        else { b.vy = 0; b.vx *= 0.8; b.landed = b.landed || t; }
      }
      var alpha = 1;
      if (b.landed) { alpha = 1 - (t - b.landed) / 1200; if (alpha <= 0) { beans.splice(j, 1); continue; } }
      drawBean(b.x, b.y, br, b.a, b.c, alpha, true);
    }
    ctx.restore();

    /* foreground floating beans with depth */
    for (var f = 0; f < floaters.length; f++) {
      var fl = floaters[f];
      fl.x += fl.vx * k; fl.a += fl.va * k;
      var fy = fl.y + Math.sin(t / 1800 + fl.ph) * 14 * fl.z;
      if (fl.x > W + 60) floaters[f] = fl = newFloater(false);
      var ox = fine ? px * 30 * fl.z : 0, oy = fine ? py * 20 * fl.z : 0;
      drawBean(fl.x + ox, fy + oy, fl.r, fl.a, fl.c, fl.z > 1.1 ? 0.55 : 0.85, true);
    }

    raf = requestAnimationFrame(frame);
  }

  function start() { if (running) return; running = true; last = 0; raf = requestAnimationFrame(frame); }
  function stop() { running = false; cancelAnimationFrame(raf); }

  function init() {
    layout();
    if (fine) hero.addEventListener('pointermove', function (e) {
      var r = hero.getBoundingClientRect();
      mx = (e.clientX - r.left) / r.width - 0.5; my = (e.clientY - r.top) / r.height - 0.5;
    });
    hero.addEventListener('pointerleave', function () { mx = 0; my = 0; });
    var io = new IntersectionObserver(function (es) { es[0].isIntersecting && !document.hidden ? start() : stop(); });
    io.observe(hero);
    document.addEventListener('visibilitychange', function () { document.hidden ? stop() : (hero.getBoundingClientRect().bottom > 0 && start()); });
    var rt; window.addEventListener('resize', function () { clearTimeout(rt); rt = setTimeout(layout, 150); });
  }
  var go = function () { setTimeout(init, 300); };
  if (img.complete && img.naturalWidth) go(); else img.addEventListener('load', go, { once: true });
})();
